var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// src/get-live-chat-config.ts
import { leagueFetch } from "@leagueplatform/league-fetch";
import { captureError } from "@leagueplatform/observability";
import { deserialise } from "kitsu-core";

// src/constants/live-chat-requests.constants.ts
var LIVE_CHAT_CONFIG_PATH = "/v1/live-chat-configs";
var LIVE_CHAT_START_CHAT_PATH = "/v1/live-chat";

// src/get-live-chat-config.ts
var getLiveChatConfig = () => __async(void 0, null, function* () {
  var _a;
  const response = yield leagueFetch(`${LIVE_CHAT_CONFIG_PATH}`);
  if (!response.ok) {
    throw new Error(`get live chat config error: ${response.status}`);
  }
  if (response.ok) {
    const clonedResponse = yield response.clone().json();
    if (!((_a = clonedResponse.data) == null ? void 0 : _a.length)) {
      captureError(
        new Error(
          "API get live chat config error: missing configuration or bad data"
        ),
        {
          tags: { requestUrl: response.url },
          context: {
            "Response Info": {
              response: JSON.stringify(clonedResponse)
            }
          }
        }
      );
    }
  }
  return deserialise(response.json());
});

// src/post-start-chat.ts
import { leagueFetch as leagueFetch2 } from "@leagueplatform/league-fetch";
var postStartChat = (answers) => __async(void 0, null, function* () {
  const response = yield leagueFetch2(LIVE_CHAT_START_CHAT_PATH, {
    method: "POST",
    body: JSON.stringify({
      data: {
        type: "thread",
        attributes: {
          answers
        }
      }
    })
  });
  if (!response.ok) {
    throw new Error(`postStartChat error: ${response.status}`);
  }
  return response.json();
});
export {
  LIVE_CHAT_CONFIG_PATH,
  getLiveChatConfig,
  postStartChat
};
//# sourceMappingURL=index.js.map